import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { useMemo, useState } from 'react';
import AdditionalPaymentModal from '../additionalPaymentsModal/AdditionalPaymentModal';

export function WisdomDataTable({data, columns, onSubmit, rows=25, header, loading, showToolbar= false, filters, globalFilters, totalRecords, onPage, first}){
    const [dialogOpen, setDialogOpen] = useState(false)

    const leftToolbarTemplate = () => {
        return(
            <Button label='Add Payment' severity="info" onClick={() => setDialogOpen(true)}/>
        )
    }

    const addPayment = (payment) => {
        onSubmit(payment)
        setDialogOpen(false)
    }   


    const filteredData = useMemo(() => {
        if (!filters?.global?.value) return data;

        const search = filters.global.value.toLowerCase();

        return data.filter((item) => {
            return globalFilters.some((field) => {
            return String(item[field] || "")
                .toLowerCase()
                .includes(search);
            });
        });
    }, [data, filters, globalFilters]);
    

    return(
        <div>
            {showToolbar && (
                <Toolbar start={leftToolbarTemplate} ></Toolbar>
            )}
            
            <DataTable 
                value={filteredData} 
                paginator 
                rows={rows} 
                first={first}
                totalRecords={totalRecords}
                onPage={onPage}
                header={header} 
                emptyMessage="No data found"
                loading={loading}
                filters={filters}
                lazy
                globalFilterFields={globalFilters}
                stripedRows
            >
                {columns.map((column, i) => {
                    return(
                        <Column 
                            key={column.field}
                            field={column.field} 
                            header={column.header} 
                            body={column?.body}
                            bodyStyle={column?.bodyStyle}
                            headerStyle={column?.headerStyle}
                        />
                    )
                })}

            </DataTable>
            {dialogOpen && <AdditionalPaymentModal onCancel={() => setDialogOpen(false)} addPayment={addPayment} />}    
        </div>
    )
}

export default WisdomDataTable;